import { IApiManagerData } from '@/modules/ApiManagerModule/interfaces/apiManager';

// cspell:disable
export const ApiManagerListMock: IApiManagerData[] = [
  {
    apiKeyId: '5b69848c-0333-41d3-a8a7-843848b9ca4d',
    name: 'api-token',
    createdAt: '2024-05-26T21:46:45.000Z',
    apiKey:
      'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJ2IjoiMiIsInR5cGUiOiJhcGkiLCJ0b2tlbklkIjoiNWI2OTg0OGMtMDMzMy00MWQzLWE4YTctODQzODQ4YjljYTRkIiwiYWNjb3VudElkIjo1OTcxLCJpYXQiOjE3MTY3NzA4MDZ9.TzXWqddgdW_o6PKZ_qyLoqhISqsfdM5eoxD44w8rg06J0yFvaTTxbEBmIJJ0SBM27Ku12eEzG-0b17WaPyx7YQ',
  },
  {
    apiKeyId: '0b78e4e5-3336-4a40-b4aa-7fbe8d4fec09',
    name: 'api-token',
    createdAt: '2024-05-26T21:47:35.007Z',
    apiKey:
      'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJ2IjoiMiIsInR5cGUiOiJhcGkiLCJ0b2tlbklkIjoiMGI3OGU0ZTUtMzMzNi00YTQwLWI0YWEtN2ZiZThkNGZlYzA5IiwiYWNjb3VudElkIjo1OTcxLCJpYXQiOjE3MTY3NzA4NTZ9.iIRBT0TV12uFyssbpM7SWpaEKpUzBXVBidOtsd0eAsFRw609N1sAGlAd6ufGzdqgf5DO_IWGqg85asdwf6ZlJA',
  },
  {
    apiKeyId: '1346935a-e94d-4be0-bb96-8562dd5ce6aa',
    name: 'api-token',
    createdAt: '2024-05-27T11:58:38.723Z',
    apiKey:
      'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJ2IjoiMiIsInR5cGUiOiJhcGkiLCJ0b2tlbklkIjoiMTM0NjkzNWEtZTk0ZC00YmUwLWJiOTYtODU2MmRkNWNlNmFhIiwiYWNjb3VudElkIjo1OTcxLCJpYXQiOjE3MTY4MjE5MTl9.11ffF_RmT6zEs-_OuaAoQWEq9fxHsY-9YFwYnE1cH22iE5t47_VtX8SImWCuvH_Y9wB2yQ6r3a4eeHwvEo7AQw',
  },
  {
    apiKeyId: 'c02e2801-54c2-41e3-93a0-68c34c47bc97',
    name: 'api-token',
    createdAt: '2024-05-29T14:33:08.617Z',
    apiKey:
      'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJ2IjoiMiIsInR5cGUiOiJhcGkiLCJ0b2tlbklkIjoiYzAyZTI4MDEtNTRjMi00MWUzLTkzYTAtNjhjMzRjNDdiYzk3IiwiYWNjb3VudElkIjo1OTcxLCJpYXQiOjE3MTcwMDM5ODl9.pwrGC3GMJXMgcPP9Dyi97_dvuLkCZSBqpts_b4_SBopbE40h3TLZyxflcFnhluqb0bZNpay--F7FqVnnNveT2Q',
  },
];
